import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';

const CreateSubscription = ({ customerId, customerName, onSubscriptionCreated, onCancel }) => {
  const [formData, setFormData] = useState({
    customerId: customerId || '',
    package: 'basic',
    startDate: new Date().toISOString().split('T')[0],
    autoRenew: false,
    notes: '',
  });
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!customerId) {
      fetchCustomers();
    }
  }, [customerId]);

  const fetchCustomers = async () => {
    try {
      const data = await apiRequest('/admin/customers');
      if (data && data.success) {
        setCustomers(data.data || []);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!formData.customerId) {
      setError('يجب اختيار عميل');
      setLoading(false);
      return;
    }

    try {
      const data = await apiRequest('/admin/subscriptions', {
        method: 'POST',
        body: JSON.stringify(formData),
      });

      if (data.success) {
        setSuccess('تم إنشاء الاشتراك بنجاح');
        setTimeout(() => {
          onSubscriptionCreated(data.data);
        }, 1500);
      } else {
        setError(data.message || data.errors?.join(', ') || 'حدث خطأ أثناء إنشاء الاشتراك');
      }
    } catch (error) {
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">إضافة اشتراك جديد</h2>
      </div>

      <form onSubmit={handleSubmit}>
        {!customerId && (
          <div className="form-group">
            <label className="form-label">العميل *</label>
            <select
              name="customerId"
              className="form-control"
              value={formData.customerId}
              onChange={handleChange}
              required
            >
              <option value="">اختر عميل</option>
              {customers.map((customer) => (
                <option key={customer._id} value={customer._id}>
                  {customer.name} ({customer.email})
                </option>
              ))}
            </select>
          </div>
        )}

        {customerId && (
          <div className="form-group">
            <label className="form-label">العميل</label>
            <input
              type="text"
              className="form-control"
              value={customerName || 'العميل المحدد'}
              disabled
            />
            <input type="hidden" name="customerId" value={customerId} />
          </div>
        )}

        <div className="form-group">
          <label className="form-label">الباقة *</label>
          <select
            name="package"
            className="form-control"
            value={formData.package}
            onChange={handleChange}
            required
          >
            <option value="basic">أساسي</option>
            <option value="standard">قياسي</option>
            <option value="premium">مميز</option>
          </select>
          <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
            جميع الاشتراكات سنوية (12 شهر)
          </small>
        </div>

        <div className="form-group">
          <label className="form-label">تاريخ البدء</label>
          <input
            type="date"
            name="startDate"
            className="form-control"
            value={formData.startDate}
            onChange={handleChange}
            required
          />
          <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
            سيتم حساب تاريخ الانتهاء تلقائياً (سنة واحدة من تاريخ البدء)
          </small>
        </div>

        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              name="autoRenew"
              checked={formData.autoRenew}
              onChange={handleChange}
            />
            <span>التجديد التلقائي</span>
          </label>
          <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
            سيتم تجديد الاشتراك تلقائياً عند انتهاء الفترة
          </small>
        </div>

        <div className="form-group">
          <label className="form-label">ملاحظات (اختياري)</label>
          <textarea
            name="notes"
            className="form-control"
            rows="3"
            value={formData.notes}
            onChange={handleChange}
            placeholder="أضف أي ملاحظات أو معلومات إضافية..."
          />
        </div>

        {error && (
          <div className="badge badge-danger" style={{ marginBottom: '1rem', display: 'block', padding: '0.75rem' }}>
            {error}
          </div>
        )}

        {success && (
          <div className="badge badge-success" style={{ marginBottom: '1rem', display: 'block', padding: '0.75rem' }}>
            {success}
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            إلغاء
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'جاري الإنشاء...' : 'إنشاء اشتراك'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateSubscription;

